export default __webpack_public_path__ + "static/media/noverde-business-logo.1e793fe8.svg";